/**
 * Loading-aware button with icon-only and icon-button variants.
 */
import { LoadingButton } from "@mui/lab";
import { Icon, IconButton } from "@mui/material";
import React from "react";
import PropTypes from "prop-types";

/**
 * Primary action button built on MUI LoadingButton.
 *
 * @param {{ className?: string, startIcon?: string, endIcon?: string, children?: React.ReactNode, iconButton?: boolean, iconOnly?: boolean }} props
 */
const VButton = (props) => {
  const { className, startIcon, endIcon, children, iconButton, iconOnly, ...rest } = props;

  return (
    <>
      {iconButton && (
        <LoadingButton
          className={`${className} p-2 min-w-0 normal-case`}
          sx={{ borderRadius: "8px" }}
          {...rest}
          // disableElevation
        >
          {children}
        </LoadingButton>
      )}
      {iconOnly && (
        <IconButton className={`${className} min-w-0`} sx={{ padding: "8px" }} {...rest}>
          {children}
        </IconButton>
      )}
      {!iconButton && !iconOnly && (
        <LoadingButton className={`normal-case ${className}`} startIcon={startIcon ? <Icon>{startIcon}</Icon> : null} endIcon={endIcon ? <Icon>{endIcon}</Icon> : null} loadingPosition={startIcon ? "start" : undefined} {...rest}>
          {children}
        </LoadingButton>
      )}
    </>
  );
};

VButton.defaultProps = {
  className: "",
  startIcon: null,
  endIcon: null,
  children: "",
  iconButton: false,
  iconOnly: false,
  // disabled: false,
  // loading: false
};

VButton.propTypes = {
  className: PropTypes.string.isRequired,
  startIcon: PropTypes.string,
  endIcon: PropTypes.string,
  children: PropTypes.any,
  iconButton: PropTypes.bool,
  iconOnly: PropTypes.bool,
  emitPaginationChange: PropTypes.func,
};

export default VButton;
